/**
 * Jotai-состояние активного воркспейса. Read/write зеркалит localStorage,
 * чтобы axios-перехватчик `@api/meerec/client` видел выбор синхронно.
 */
import {atom} from 'jotai';
import {
  clearActiveWorkspaceId,
  readActiveWorkspaceId,
  writeActiveWorkspaceId,
} from './lib/storage';

const baseActiveWorkspaceIdAtom = atom<string | null>(readActiveWorkspaceId());

/** Id активного воркспейса. Запись синхронизируется в localStorage. */
export const activeWorkspaceIdAtom = atom(
  (get) => get(baseActiveWorkspaceIdAtom),
  (_get, set, next: string | null) => {
    set(baseActiveWorkspaceIdAtom, next);
    if (next) writeActiveWorkspaceId(next);
    else clearActiveWorkspaceId();
  },
);
